// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"coinInfoDescription-module--wrapper--2Nf_g","blog":"coinInfoDescription-module--blog--O3mUm","info":"coinInfoDescription-module--info--1zvzT"};